<template>
  <v-app-bar absolute dense dark>
    <v-toolbar-title>MAKjustID</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn to="login">
      <v-icon dark>login</v-icon>
    </v-btn>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" to="/">
          <v-icon dark>home</v-icon>
        </v-btn>
      </template>
      <span>HOME</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
export default {};
</script>

<style>
</style>